import React from 'react';
import WysiwygField from '../../../components/WysiwygField';

import './style.scss';

const TextBlock = ({ entity }) => {
  return (
    <WysiwygField
      property="schema:text"
      className="TextBlock subheading2"
      html={entity.getIn(['body', 0, 'processed'])}
    />
  );
};

export default TextBlock;
